import React from 'react';
import classes from './PageErrorMessage.css';
import Button from '../../UI/Button/Button.jsx';

const pageErrorMessage = (props) => {

  return <div className={classes.Wrapper}>

    <p className={classes.errorMessage}>Whoops! Something went wrong.  The page can't be loaded. Try reloading the page.
  </p>

    <Button btnType={'Neutral'} clicked={() => { window.location.reload() }}>Reload
  </Button></div>

}

export default pageErrorMessage;


// WEBPACK FOOTER //
// ./src/components/miscUtility/pageErrorMessage/PageErrorMessage.jsx